import { CircularProgress } from "@mui/material";
import { ErrorIcon, SuccessIcon, WarningIcon} from "../components/common/icons";
import { isValid } from "date-fns";

export const integrationEntityMap = {
    permission_details: "permissionDetail",
    role: "role",
    profile: "profile",
    employee: "employee",
    authority_detail: "authorityDetail",
    metadata_object: "metadataObject",
    role_1c: "role1C",
    employee_1c: "employee1C",
    role_other: "roleOther",
    employee_other: "employeeOther",
    manual_integration: "manualIntegration",
    common: "common"
};

export const integrationReverseEntityMap = {
    permissionDetail: "permission_details",
    role: "role",
    profile: "profile",
    employee: "employee",
    authorityDetail: "authority_detail",
    metadataObject: "metadata_object",
    role1C: "role_1c",
    employee1C: "employee_1c",
    roleOther: "role_other",
    employeeOther: "employee_other",
    manualIntegration: "manual_integration",
    common: "common"
};

export const getIntegrationIcon = (status) => {
    switch (status) {
        case "manual":
            return SuccessIcon;

        case "success":
            return SuccessIcon;

        case "error":
        case "connection_lost":
            return ErrorIcon;

        case "pending":
            return CircularProgress;

        default:
            return WarningIcon;
    }
};

export const convertDateToString = (intl, date) => {
    if (!date) {
        return "";
    }

    const dateObj = date instanceof Date
        ? date
        : new Date(date);

    let dateString = isValid(dateObj) ? intl.formatDate(dateObj, {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    }) : "";

    return dateString;
};

export const getScheduleTypeTextWithIntl = (intl, type) => {
    return intl.formatMessage({ id: `schedule-maintenance-dialog.schedule-type.${type}` });
};

export const SYSTEM_TYPES = {
    SAP: "SAP",
    ONE_C: "1C",
    OTHER: "OTHER"
}

export const getEntityTextWithIntl = (intl, entity) => {
    switch (entity) {
        
        //SAP
        case "role":
            return intl.formatMessage({ id: "integration-details-row.roles.text" })
        case "employee":
            return intl.formatMessage({ id: "integration-details-row.users.text" })
        case "profile":
            return intl.formatMessage({ id: "integration-details-row.profiles.text" })
        case "permissionDetail":
            return intl.formatMessage({ id: "integration-system-box.checkbox-permission-details" })
        case "manualIntegration":
            return intl.formatMessage({ id: "integration-details-row.manual-integration.text" })


        //1C
        case "authorityDetail": 
            return intl.formatMessage({ id: "integration-details-row.authority-detail.text" }) 
        case "metadataObject": 
            return intl.formatMessage({ id: "integration-details-row.metadata-object.text" })
        case "employee1C": 
            return intl.formatMessage({ id: "integration-details-row.users.text" })
        case "role1C": 
            return intl.formatMessage({ id: "integration-details-row.roles.text" })


        case "employeeOther": 
            return intl.formatMessage({ id: "integration-details-row.users.other.text" })
        case "roleOther": 
            return intl.formatMessage({ id: "integration-details-row.roles.other.text" })

        default:
            return "";
    }
}

export const getStatusTextWithIntl = (intl, status) => {
    const statusId = `integration-settings-page.status.${status}`;
    return intl.formatMessage({ id: statusId });
}

export const getSystemSyncTitle = (intl, status, lastSyncDate, type) => {
    let titleId = `integration-system-box.sync-status.${type}.`;

    switch (status) {
        case "success":
        case "warning":
        case "error":
            titleId += "true";
            break;
        case "pending":
        case "connection_lost":
            titleId += status;
            break;
        default:
            titleId += "false";
            break;
    }

    const title = intl.formatMessage({ id: titleId });

    if (!lastSyncDate) {
        return title;
    }

    const dateString = convertDateToString(intl, lastSyncDate);

    return dateString ? `${title} ${dateString}` : title;
};

export const getCheckedByEntitySAP = (currentChecked, entity) => {
    const result = {...currentChecked};
    const entityChecked = currentChecked[entity];

    switch (entity) {
        case "profile":
            if (!entityChecked) {
                result.role = false;
                result.employee = false;
            }
            break;

        case "role":
            if (entityChecked) {
                result.profile = true;
            } else {
                result.profile = false;
                result.employee = false;
            }
            break;
        
        case "employee":
            if (entityChecked) {
                result.profile = true;
                result.role = true;
            } else {
                result.profile = false;
                result.role = false;
            }
            break;
    }

    return result;
};

export const getCheckedByEntity1C = (currentChecked, entity) => {
    const result = {...currentChecked};
    const entityChecked = currentChecked[entity];

    switch (entity) {
        case "authorityDetail":
            if (!entityChecked) {
                result.metadataObject = false;
                result.employee1C = false;
                result.role1C = false;
            }
            break;

        case "metadataObject":
            if (entityChecked) {
                result.authorityDetail = true;
            }
            if (!entityChecked) {
                result.authorityDetail = false;
                result.employee1C = false;
                result.role1C = false;
            }
            break;

        case "employee1C":
            if (entityChecked) {
                result.authorityDetail = true;
                result.metadataObject = true;
            }
            if (!entityChecked) {
                result.authorityDetail = false;
                result.metadataObject = false;
                result.role1C = false;
            }
            break;
        
        case "role1C":
            if (entityChecked) {
                result.authorityDetail = true;
                result.metadataObject = true;
                result.employee1C = true;
            }
            if (!entityChecked) {
                result.authorityDetail = false;
                result.metadataObject = false;
                result.employee1C = false;
            }
            break;
    }

    return result;
};


export const getCheckedByEntityOther = (currentChecked, entity) => {
    const result = {...currentChecked};
   // const entityChecked = currentChecked[entity];

    switch (entity) {
        case "employeeOther":
            break;
        
        case "roleOther":
            break;
    }

    return result;
};
